import React from 'react';
import { bookingStatusOptions, translateOptionValue } from '../../../../components/exl/shared/translations';
import InfoSection from './info-section';
import { useTranslation } from 'react-i18next';
import { COURSE_BOOKINGS_NO_PARTICIPANTS, COURSE_BOOKINGS_STATUS_LABEL } from '../../../../i18n/keyConstants';

export default function CourseBookings({ course, bookings, bookingType }) {

    const { t } = useTranslation('courseBookings');

    if (bookings?.length < 1) {
        return (
            <div style={{ color: "grey", paddingBottom: "24px" }}>{t(COURSE_BOOKINGS_NO_PARTICIPANTS, { bookingType: bookingType })}</div>
        )
    }

    return (
        <div>
            {bookings.toSorted((a, b) => a.coaEmpName.localeCompare(b.coaEmpName)).map((booking) => (
                <div className={"card ml-auto p-2 mb-2 list-card"} key={booking.id}>

                    <InfoSection marginBottom={"0px"} marginTop={"2px"} sectionLabel={t(translateOptionValue(booking.status, bookingStatusOptions), { ns: 'shared' })}>
                        <a href={`/employee/${booking.coaEmpId.toLowerCase()}/info`}>
                            {booking.coaEmpName}
                        </a>
                    </InfoSection>

                    <InfoSection sectionLabel={t(COURSE_BOOKINGS_STATUS_LABEL)}>
                        {t(translateOptionValue(booking.status, bookingStatusOptions), { ns: 'shared' })}
                    </InfoSection>
                </div>
            ))}
        </div>
    )
}
